import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Cancelar',
          onClick: _ctx.clickDeny,
          "is-cancel": true,
          class: "full"
        }, null, 8, ["onClick"]),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Aceptar',
          class: "full",
          onClick: _ctx.clickAccept
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}